// src/blocks/image/image-url-builder.ts
import imageUrlBuilder from "@sanity/image-url";
var DEFAULT_IMAGE_SIZE = 100;
var DEFAULT_FALLBACK_IMAGE_QUALITY = 75;
var SANITY_PROJECT_DETAILS = {
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || process.env.SANITY_STUDIO_PROJECT_ID || "",
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET || process.env.SANITY_STUDIO_DATASET_ACTIVE || "production"
};
var DEFAULT_IMAGE_BUILDER = (imageUrlBuilder2, options) => {
  const result = imageUrlBuilder2.quality(options.quality || DEFAULT_FALLBACK_IMAGE_QUALITY).fit("clip");
  if (options.width !== null) {
    return result.width(options.width);
  }
  return result;
};
function getSanityRefId(image) {
  if (typeof image === "string") {
    return image;
  }
  return image.asset?._ref || image.asset?._id || "";
}
function getImageDimensions(id) {
  const dimensions = id.split("-")[2] || `${DEFAULT_IMAGE_SIZE}x${DEFAULT_IMAGE_SIZE}`;
  const [width = DEFAULT_IMAGE_SIZE, height = DEFAULT_IMAGE_SIZE] = dimensions.split("x").map((num) => Number.parseInt(num, 10));
  const aspectRatio = width / height;
  return { width, height, aspectRatio };
}
function getCroppedDimensions(image, baseDimensions) {
  const crop = image.crop;
  if (!crop) {
    return baseDimensions;
  }
  const { width, height } = baseDimensions;
  const croppedWidth = width * (1 - (crop.left + crop.right));
  const croppedHeight = height * (1 - (crop.top + crop.bottom));
  return {
    width: croppedWidth,
    height: croppedHeight,
    aspectRatio: croppedWidth / croppedHeight
  };
}
function buildNextSanityImage(image, options, size) {
  const imageBuilder = options?.imageBuilder || DEFAULT_IMAGE_BUILDER;
  if (!image) {
    return null;
  }
  const id = image ? getSanityRefId(image) : null;
  if (!id) {
    return null;
  }
  const originalImageDimensions = getImageDimensions(id);
  const croppedImageDimensions = getCroppedDimensions(
    image,
    originalImageDimensions
  );
  const baseImgBuilderInstance = imageBuilder(
    imageUrlBuilder(SANITY_PROJECT_DETAILS).image(image).auto("format"),
    {
      width: Number(size?.width) || null,
      originalImageDimensions,
      croppedImageDimensions,
      quality: null
    }
  );
  const width = baseImgBuilderInstance.options.width || (baseImgBuilderInstance.options.maxWidth ? Math.min(
    baseImgBuilderInstance.options.maxWidth,
    croppedImageDimensions.width
  ) : croppedImageDimensions.width);
  const height = baseImgBuilderInstance.options.height || (baseImgBuilderInstance.options.maxHeight ? Math.min(
    baseImgBuilderInstance.options.maxHeight,
    croppedImageDimensions.height
  ) : Math.round(width / croppedImageDimensions.aspectRatio));
  return {
    src: baseImgBuilderInstance.url(),
    width,
    height,
    blurDataURL: image.blurDataURL,
    alt: image.altText || ""
  };
}
var isSanityImageProps = (image) => {
  if ("sanityImageSourceData" in image) return true;
  return false;
};

export {
  DEFAULT_FALLBACK_IMAGE_QUALITY,
  getImageDimensions,
  getCroppedDimensions,
  buildNextSanityImage,
  isSanityImageProps
};
